import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  MAXX_TRIGGER_TOOLTIP_ANALYZE,
  MAXX_TRIGGER_TOOLTIP_VIEW,
  MaxxAnalysisRowState,
} from '../../services/maxx-test-analysis.model';

@Component({
  selector: 'maxx-analysis-trigger',
  templateUrl: './maxx-analysis-trigger.component.html',
  styleUrls: ['./maxx-analysis-trigger.component.scss'],
  standalone: false,
})
export class MaxxAnalysisTriggerComponent implements OnChanges {
  @Input({ required: true }) state: MaxxAnalysisRowState;
  @Input({ required: true }) panelId: string;
  @Input({ required: true }) triggerId: string;

  @Output() triggerClick = new EventEmitter<Event>();

  tooltip = MAXX_TRIGGER_TOOLTIP_ANALYZE;
  hasAnalysis = false;

  ngOnChanges(): void {
    this.hasAnalysis = this.state.status === 'loaded' || this.state.status === 'error';
    this.tooltip = this.hasAnalysis ? MAXX_TRIGGER_TOOLTIP_VIEW : MAXX_TRIGGER_TOOLTIP_ANALYZE;
  }
}
